import { useState } from 'react'

export function usePdfViewerPages({ pdfViewerRef, onSelectThumbnailPage }) {
  const [pagesCount, setPagesCount] = useState(null)
  const [activePage, setActivePage] = useState(1)

  function handlePagesInit(pdfViewer) {
    setPagesCount(pdfViewer.pagesCount)
    setActivePage(pdfViewer.currentPageNumber)
  }

  function handlePageChanging({ pageNumber }) {
    setActivePage(pageNumber)
  }

  function resetPages() {
    setPagesCount(null)
    setActivePage(1)
  }

  function handleChangePageInput(nextPage) {
    pdfViewerRef.current.currentPageNumber = nextPage
  }

  function handleSelectThumbnailPage(nextPage) {
    onSelectThumbnailPage?.()
    handleChangePageInput(nextPage)
  }

  function handlePrevClick() {
    pdfViewerRef.current.currentPageNumber -= 1
  }

  function handleNextClick() {
    pdfViewerRef.current.currentPageNumber += 1
  }

  return {
    activePage,
    navigationProps: {
      activePage,
      handleChangePageInput,
      handleNextClick,
      handlePrevClick,
      pagesCount,
    },
    resetPages,
    onPageChanging: handlePageChanging,
    onPagesInit: handlePagesInit,
    onSelectThumbnailPage: handleSelectThumbnailPage,
  }
}
